import { Params } from "./tracker/validator";
import { RequestError } from "./utils/classes/RequestError";

export interface Data {
  params: Params;
}

export interface Requests {
  post: (url: string, data: Data) => Promise<void>;
}

const RequestsWrapper = (apiKey: string): Requests => {
  const baseURL = "https://analytics.locallogic.co/track-v2";

  async function post(url: string, data: Data) {
    const response = await fetch(`${baseURL}${url}`, {
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        Authorization: apiKey,
        "Content-type": "application/json",
      },
      method: "POST",
    });

    if (!response.ok) {
      // Try to parse message
      let error;

      try {
        error = await response.json();
      } catch (_error) {
        // Do nothing
      }

      // Discard unauthorized messages since they are not useful
      const message = error?.message ? error.message : "";

      if (message.toLowerCase() !== "unauthorized") {
        throw new RequestError(`Could not post tracking event: ${message}`);
      }
    }
  }

  return {
    post,
  };
};

export default RequestsWrapper;
